import React, { Suspense, lazy, ComponentType } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

// Each page is its own download, fetched the first time it is opened, so opening the
// report no longer downloads Be-Planned, the campaign and AI screens first (the whole
// admin used to be one ~9.7 MB download on every page).
//
// After a deploy the old page files are gone from hosting, so a tab opened before it
// would fail on its first visit to a page it had not loaded yet. Reload once instead
// (the reload brings the new build); a second failure in the same tab is shown as before.
const PageLoading = () => (
  <div style={{ display: "flex", justifyContent: "center", padding: "80px 0" }}>
    <CircularProgress style={{ color: "#1D4E89" }} />
  </div>
);

const RELOAD_FLAG = "page-chunk-reload";

const loadWithReload = (load: () => Promise<any>) => () =>
  load()
    .then((module) => {
      try {
        sessionStorage.removeItem(RELOAD_FLAG);
      } catch (e) {}
      return module;
    })
    .catch((error) => {
      let reloaded = true;
      try {
        reloaded = !!sessionStorage.getItem(RELOAD_FLAG);
        if (!reloaded) sessionStorage.setItem(RELOAD_FLAG, "1");
      } catch (e) {}
      if (reloaded) throw error;
      window.location.reload();
      return new Promise<any>(() => {});
    });

export const lazyPage = (
  load: () => Promise<{ default: ComponentType<any> }>
) => {
  const Page = lazy(loadWithReload(load));
  return (props: any) => (
    <Suspense fallback={<PageLoading />}>
      <Page {...props} />
    </Suspense>
  );
};

// for modules that export the page by name
export const named = (name: string) => (module: any) => ({
  default: module[name],
});
